import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { List } from '../../common/List/List';
import {
  unverifiedBenefitsList,
  unverifiedAdminCheckList,
} from '../../../constants/constants';
import { IdmeVerification } from '../../IdmeVerification';

function UnverifiedAdmin(props) {
  const { verifyOnClick, channelId, customerAccountId, userId } = props;
  const isIdmeEnabled = !!useConfigService('ENABLE_MILITARY_VERIFICATION_IDME');
  return (
    <div className="sui-grid sui-gap-y-8">
      <List variant="sm" list={unverifiedAdminCheckList} />
      {!isIdmeEnabled && (
        <p>
          Please choose the appropriate option based on your status to get
          started:{' '}
        </p>
      )}
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-4 sui-justify-items-left sui-gap-4">
        {isIdmeEnabled ? (
          <IdmeVerification
            channelId={channelId}
            customerAccountId={customerAccountId}
            userId={userId}
          />
        ) : (
          <>
            <Button variant="secondary" onClick={() => verifyOnClick(false)}>
              Military Member or Gold Star
            </Button>
            <Button variant="secondary" onClick={() => verifyOnClick(true)}>
              Spouse
            </Button>
          </>
        )}
      </div>
      <List list={unverifiedBenefitsList} />
    </div>
  );
}

UnverifiedAdmin.propTypes = {
  verifyOnClick: PropTypes.func,
  channelId: PropTypes.number,
};

UnverifiedAdmin.defaultProps = {
  verifyOnClick: () => {},
  channelId: 1,
};

export default UnverifiedAdmin;
